import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import imageCompression from "browser-image-compression";
import './Gallery.css';
import LoadingImage from '../Components/images/loading1.gif'; // Import your loading gif image
import ClearIcon from '../../src/Components/images/Clear.svg' // Import the clear icon
import toast from "react-hot-toast";
import api from "./config";
import { language_selected } from "./language";

function Gallery({ setSelectedImageInParent, passSendImageToAPI, userType, projectName, language_text }) {
  const [commitId, setCommitId] = useState('');
  const [source, setSource] = useState('');
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true); // True indicates no loading in progress
  const [ipAddress, setIpAddress] = useState();
  const sendImageToApiRef = useRef(null); // Reference to hold the sendImageToAPI function
  const [filename, setFileName] = useState();
  let popupTimeout; // Add this at the top of your component (outside the function)
  const [requestId, setRequestId] = useState('')

  useEffect(() => {
    const r = new URLSearchParams(window.location.search).get("request_id") || "";
    const params = new URLSearchParams(window.location.search);
    const cid = params.get("commit_id");
    const src = params.get("source");

    setRequestId(r)
    setCommitId(cid);
    setSource(src);
  }, [])

  const handleImageSelect = async (event) => {
    const file = event.target.files[0];

    if (file) {
      setLoading(false); // Show loader immediately after selecting an image
      setFileName(file.name); // Set the file name when a file is selected


      if (file.size < 10 * 1024) { // Check if file size is less than 10 KB
        setLoading(true); // Hide loader
        showPopupMessage(language_selected[language_text].file_size_min, "error");

        fileInputRef.current.value = "";
        setFileName("");
        return;
      }

      if (file.size > 17 * 1024 * 1024) { // Check if file size is more than 17 MB
        setLoading(true); // Hide loader
        showPopupMessage(language_selected[language_text].max_file_size, "error");

        fileInputRef.current.value = "";
        setFileName("");
        return;
      }

      if (file.type === "application/pdf") {
        setLoading(true);
        showPopupMessage(language_selected[language_text].pdf_not_supported, "error");

        fileInputRef.current.value = "";
        setFileName("");
        return;
      }

      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg" &&
        file.type !== "image/pjpeg" && // Optional: block progressive JPEG
        file.type === "image/jfif"     // Block JFIF specifically
      ) {
        setLoading(true);
        showPopupMessage(language_selected[language_text].jfif_not_supported, "error");

        fileInputRef.current.value = "";
        setFileName("");
        return;
      }


      try {
        const compressedImage = await compressImage(file);
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64String = reader.result;
          setSelectedImage(base64String); // Update local state
          setSelectedImageInParent(base64String); // Pass the base64 image to SignatureContainer

          await sendImageToAPI(base64String); // Send the image to API immediately
        };
        reader.readAsDataURL(compressedImage);
      } catch (error) {
        setLoading(true); // Hide loader
        showPopupMessage(language_selected[language_text].file_type_not_accepted, "error");

        fileInputRef.current.value = "";
        setFileName("");
      }
    }
  };

  const compressImage = async (imageFile) => {
    const options = {
      maxSizeMB: 4,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(imageFile, options);
      return compressedFile;
    } catch (error) {
      console.error("Image compression error:", error);
      throw error;
    }
  };

  const fetchIpAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      setIpAddress(response.data.ip);
    } catch (error) {
      console.error("Error fetching the IP address:", error);
    }
  };

  const sendImageToAPI = async (base64String) => {
    await fetchIpAddress(); // Fetch IP address before sending the request

    try {
      // Ensure the base64 string is in the desired format, specifically for PNG/JPEG images
      const cleanBase64String = base64String.replace(/^data:image\/(png|jpeg);base64,/, '');
      // console.log("Clean Base64 String:", cleanBase64String);
      console.log("requestId:", requestId);

      // Create a FormData object and append the cleaned Base64 image string with a key
      const formData = new FormData();
      const payload = `b'${cleanBase64String}'`;
      formData.append('image', payload); // Append as key-value pair

      const config = {
        method: "post",
        url: `${api.BASE_URL}/default/JM_pro_signvalidate_uatc;?Isdigital=0&IsSdk=1&requestid=${requestId}`,
        headers: {
          "x-api-key": api.x_api_key,
          "authorizationToken": api.authorizationToken,
        },
        data: formData,
      };

      console.log('usertype', userType);

      const response = await axios(config);
      // console.log('response', response);

      if (response.data.status === 1) {
        // console.log(response.data, "this is the complete response");
        let requestDataToSend = {
          ...response.data, userType: userType, projectName: projectName,
          commit_id: commitId,
          source: source
        };
        // console.log(requestDataToSend, "this is the complete response");
        toast.success(language_selected[language_text]?.success, {
          style: {
            background: '#13CF5D', // faint green
            color: 'white',        // white text
            border: 'none',
          },
          iconTheme: {
            primary: 'white',
            secondary: '#13CF5D',  // medium green circle
          },
        });
        window.parent.postMessage(requestDataToSend, "*");
      } else {
        showPopupMessage(
          language_selected[language_text].remarks.white_background_required,
          "error"
        );

        clearSelectedImage()
      }
    } catch (error) {
      showPopupMessage(language_selected[language_text].server_or_invalid_file, "error");

      fileInputRef.current.value = "";
      setFileName("");
      clearSelectedImage()
    } finally {
      setLoading(true); // Hide loader after API response is handled
    }
  };

  const clearSelectedImage = () => {
    // Clear selected image and reset filename
    setSelectedImage(null);
    setFileName("");
    setSelectedImageInParent(null); // Reset the selected image in the parent component
    fileInputRef.current.value = "";
  };

  // const showPopupMessage = (message, type) => {
  //   const popup = document.getElementById("popupmessage");
  //   popup.innerHTML = message;
  //   popup.style.display = "block";
  //   popup.style.backgroundColor = type === "success" ? "green" : "red";
  //   setTimeout(() => {
  //     popup.style.display = "none";
  //   }, 3000);
  // };


  const showPopupMessage = (message, type) => {
    const popup = document.getElementById("popupmessage");
    if (!popup) return;
    popup.style.display = "none"; // Hide first to reset
    popup.innerHTML = message;
    popup.style.display = "block";
    popup.style.backgroundColor = type === "success" ? "green" : "red";
    if (popupTimeout) clearTimeout(popupTimeout);
    popupTimeout = setTimeout(() => {
      popup.style.display = "none";
    }, 7000);
  };

  useEffect(() => {
    passSendImageToAPI(sendImageToAPI); // Pass it up to SignSdk
  }, []);

  // console.log('filename', filename);

  return (
    <div className="uploadSignatureDiv">
      {/* this is the upload sign image part */}
      {/* <div className="uploadTextHeading">{language_selected[language_text]?.upload_text}</div> */}

      {/* <div>
        <button onClick={() => fileInputRef.current.click()} className="uploadBtn">
          &nbsp; (JPG, JPEG, PNG-{language_selected[language_text]?.max_file_size})
        </button>
      </div> */}

      {/* Display filename and clear button */}
      {filename && (
        <div className="fileInfo">
          <div className="fileNameDisplay">
            {/* {filename} */}
            {filename && filename.length > 20 ? filename.slice(0, 20) + '...' : filename}
          </div>
          <img
            src={ClearIcon} // The clear icon image
            alt="Clear"
            className="clearIcon"
            onClick={clearSelectedImage} // Clear the selected image when clicked
          />
        </div>

      )}
      {/* 
      <div id="popupmessage" className="errorWindow" style={{ display: "none" }}></div>
      <div id="popupmessage" className="successWindow" style={{ display: "none" }}></div> */}
      <div id="popupmessage" className="popupWindow" style={{ display: "none" }}></div>

      <input
        type="file"
        id="fileInput"
        ref={fileInputRef}
        onChange={handleImageSelect}
        accept="image/*"
        style={{ display: "none" }}
      />

      {!loading && (
        <div className="loadingImgGalleryPage">
          <img src={LoadingImage} alt="Loading..." style={{ width: "150px", height: "auto" }} />
        </div>
      )}
    </div>
  );
}

export default Gallery;
